
import React from 'react';
import { JobSearchResult } from '@/types/jobSearch';
import { JobSearchResultsList } from './JobSearchResultsList';
import { SavedJob } from '@/types/jobSearch';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ErrorBoundary } from '@/components/error-handling/ErrorBoundary'; // Import ErrorBoundary

interface SavedJobsDisplayProps {
  savedJobs: SavedJob[]; 
  isFetchingSavedJobs: boolean;
  onUnsaveJob: (jobSearchResultId: string) => Promise<void>;
  onMakeLead: (job: JobSearchResult) => void;
  isSavingJobId: string | null;
  isUserLoggedIn: boolean;
}

export const SavedJobsDisplay: React.FC<SavedJobsDisplayProps> = ({
  savedJobs,
  isFetchingSavedJobs,
  onUnsaveJob,
  onMakeLead,
  isSavingJobId,
  isUserLoggedIn,
}) => {
  return (
    <ErrorBoundary>
      {isFetchingSavedJobs && <p className="text-center text-muted-foreground mt-8">Loading saved jobs...</p>}
      
      {!isFetchingSavedJobs && (() => {
        const jobResultsFromSaved = savedJobs
          .map(sj => sj.job_search_results)
          .filter(job => job !== undefined) as JobSearchResult[];
        
        const savedJobIdsFromSaved = jobResultsFromSaved.map(job => job.id);

        if (jobResultsFromSaved.length === 0) {
          return (
            <Alert className="mt-8">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle>No Saved Jobs</AlertTitle>
              <AlertDescription>
                You haven't saved any jobs yet. Use the "Save" button on search results to add jobs here.
              </AlertDescription>
            </Alert>
          );
        }

        return (
          <div className="mt-6">
            <JobSearchResultsList
              results={jobResultsFromSaved}
              savedJobIds={savedJobIdsFromSaved}
              onSaveJob={async (jobId) => { console.warn("Attempted to save an already saved job from saved list:", jobId)}}
              onUnsaveJob={onUnsaveJob}
              isSavingJobId={isSavingJobId}
              isUserLoggedIn={isUserLoggedIn}
              onMakeLead={onMakeLead}
            />
          </div>
        );
      })()}
    </ErrorBoundary>
  );
};
